import { useStaticQuery, graphql } from 'gatsby'

export const useCourtsQuery = () => {
const { wpPage } = useStaticQuery(
    graphql`
    query CourtsQuery {
      wpPage(slug: {eq: "courts"}) {
        courts {
          courtsWeServe
        }
      }
    }
    
  `
);
return wpPage.courts;
}